import React, { memo, useState, useEffect } from "react";
import { scaleLinear } from "d3-scale";
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography,
} from "react-simple-maps";
import * as d3 from "d3";
import ReactTooltip from "react-tooltip";

const geoUrl = "https://enjalot.github.io/wwsd/data/world/world-110m.geojson";

export const MapChart = ({
  chartTitle,
  identifier,
  data = [],
  onEntityClick,
  isEmbededWidget,
}) => {
  const minZoom = 1;
  const maxZoom = 20;
  const [countryGroup, setCountryGroup] = useState({});
  const [tooltipContent, setTooltipContent] = useState("");
  const [position, setPosition] = useState({
    coordinates: [0, 0],
    zoom: 1,
  });

  let colorScale = scaleLinear().domain([0, 100]).range(["lightgray", "blue"]);

  useEffect(() => {
    // mapping feeds and feed count with respective countries
    let cG = {};
    d3.json(geoUrl).then((res) => {
      let features = res.features;
      Array.from(features).forEach((f) => {
        let feedGroup = data.filter((feed) => {
          if (f.properties.name == feed.country) {
            return feed;
          }
        });
        cG = {
          ...cG,
          ...{
            [f.properties.name]: {
              feeds: feedGroup,
              feedsCount: feedGroup.length,
            },
          },
        };
      });
      setCountryGroup(cG);
    });
  }, [data]);

  function getPointsInRegion(cName) {
    try {
      let cityGroup = data.filter((data) => {
        return cName === data.country;
      });
      return cityGroup.length;
    } catch (e) {
      return 0;
    }
  }

  // zoom handlers
  const handleZoomIn = (e) => {
    e.preventDefault();
    if (position.zoom >= maxZoom) return;
    setPosition((pos) => ({ ...pos, zoom: pos.zoom + 1 }));
  };

  const handleZoomOut = (e) => {
    e.preventDefault();
    if (position.zoom <= minZoom) return;
    setPosition((pos) => ({ ...pos, zoom: pos.zoom - 1 }));
  };

  const handleMouseEnter = (e, geo) => {
    if (
      geo.geometry &&
      (geo.geometry.type === "Polygon" || geo.geometry.type === "MultiPolygon")
    )
      setTooltipContent(
        `${geo.properties.name}: Total Feeds — ${
          countryGroup &&
          countryGroup[geo.properties.name] &&
          countryGroup[geo.properties.name].feedsCount
        }`
      );
  };
  const handleMouseLeave = () => {
    setTooltipContent("");
  };

  const handleGeoClick = (geo) => {
    onEntityClick(
      {},
      {
        country: geo.properties.name,
        countryFeeds: countryGroup,
      }
    );
  };
  const uniqueIdentifier = isEmbededWidget
    ? `embedded-${identifier}`
    : identifier;

  return (
    <div className="worldMapWrap">
      <div className="widgetHeading">{chartTitle}</div>
      <div className="controls">
        <button onClick={(e) => handleZoomIn(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke="black"
            strokeWidth="3"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
        <button onClick={(e) => handleZoomOut(e)} style={{ marginTop: "5px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke="black"
            strokeWidth="3"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
      </div>
      <div id={uniqueIdentifier}>
        <ComposableMap
          projection="geoMercator"
          data-tip=""
          projectionConfig={{ scale: 100 }}
          height={isEmbededWidget ? 400 : 350}
        >
          <ZoomableGroup
            zoom={position.zoom}
            center={position.coordinates}
            minZoom={minZoom}
            maxZoom={maxZoom}
          >
            {" "}
            <Geographies geography={geoUrl}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const density = getPointsInRegion(geo.properties.name);
                  const fillColor = density
                    ? colorScale(
                        Math.floor(((density * 2) / data.length) * 100)
                      )
                    : "lightgray";

                  return (
                    <Geography
                      key={geo.properties.name + "_"}
                      geography={geo}
                      onMouseEnter={(e) => handleMouseEnter(e, geo)}
                      onMouseLeave={() => handleMouseLeave()}
                      onClick={() => handleGeoClick(geo)}
                      style={{
                        default: {
                          fill: fillColor,
                          outline: ["black"],
                        },
                        hover: {
                          fill: "#4dff97",
                          outline: "none",
                        },
                      }}
                    />
                  );
                })
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>
        <ReactTooltip>{tooltipContent}</ReactTooltip>
      </div>
    </div>
  );
};

export default memo(MapChart);
